import './CustomModal.css';

import * as React from 'react';

const CustomModal = ({ children, show,onClose,dd}) => {
    
    return (        
        <>
            <div className=" modal fade customModal show " 
            style={{display: show ? 'block' : 'none' }}
            name="exampleModal"  aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className={dd+" modal-dialog modal-dialog-centered modal-dialog-scrollable"}>
                    <div className="modal-content">
                    {/*
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" 
                            aria-label="Close"
                            onClick={(e)=>onClose(e)}
                            ></button>
                    </div>*/}
                        <div className="modal-body">
                            {children}
                        </div>
                        {/*<div className="modal-footer">    </div>*/}
                    </div>
                </div>
            </div>
        </>
    );
};
export default CustomModal;